export default "__VITE_ASSET__Nkqg1gDF__"